export default __webpack_public_path__ + "c939c796b937a9ee4e60c6a615ad2c1d.png";